import { createTheme, ThemeOptions } from '@mui/material/styles';

// Hanover Learning brand palette.
// Primary mirrors the v1 (shadcn) slate-900 dark neutral; secondary is the
// kelly-green from the Hanover Learning wordmark.
const palette = {
  primary: {
    main: '#0f172a', // slate-900
    light: '#334155', // slate-700
    dark: '#020617', // slate-950
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#7DC142', // Hanover green
    light: '#95D25E',
    dark: '#5FA22B',
    contrastText: '#ffffff',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
  },
  background: {
    default: '#f8fafc', // slate-50
    paper: '#ffffff',
  },
  text: {
    primary: '#0f172a',
    secondary: '#475569', // slate-600
  },
  divider: '#e2e8f0', // slate-200
};

// Theme configuration
const themeOptions: ThemeOptions = {
  palette,
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
  },
};

// Create and export theme
export const theme = createTheme(themeOptions);

// Sidebar width constant for layout
export const SIDEBAR_WIDTH = 240;
export const TOPBAR_HEIGHT = 64;
